import { render, staticRenderFns } from "./GlobalContactForm.vue?vue&type=template&id=2787216b&scoped=true"
import script from "./GlobalContactForm.vue?vue&type=script&lang=js"
export * from "./GlobalContactForm.vue?vue&type=script&lang=js"
import style0 from "./GlobalContactForm.vue?vue&type=style&index=0&id=2787216b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2787216b",
  null
  
)

export default component.exports